import { Trans } from '@lingui/react/macro';
import { ProductOfCategory, ProductType } from '@/@types';
import { isProductOfType } from '@/services/api/parsers/utils';
import { clsx } from 'clsx';
import { UIComponent, UIProp } from '../..';
import useModals from '../modals/use-modal';
import { Button, Icon } from '../../atoms';
import * as styles from './book-table.styles';

const BookTableBtn: UIComponent<{ restaurant: ProductType; variant?: UIProp<typeof Button>['variant'] }> = ({
  restaurant,
  variant = 'secondary',
  className,
}) => {
  const openModal = useModals();

  if (!isProductOfType(restaurant, ['restaurants']) || !restaurant.extraInfo.externalId?.covermanager) {
    return null;
  }

  return (
    <Button
      variant={variant}
      size="small"
      className={clsx(styles.root, className)}
      onClick={(evt) => {
        evt.stopPropagation();
        evt.preventDefault();
        evt.bubbles = false;
        openModal({
          name: 'reservation',
          restaurant: restaurant as ProductOfCategory<'restaurants'>,
        });
      }}
    >
      <Icon name="calendar" />
      <span>
        <Trans>Book a table</Trans>
      </span>
    </Button>
  );
};
export default BookTableBtn;
